<template>
  <div id="devmg">
    <el-table :data="warningSetList" style="width: 1200px" highlight-current-row border>
      <el-table-column type="index" label="编号" width="50"></el-table-column> 
      <el-table-column prop="seed" label="设备码" width="300"></el-table-column>
	  <el-table-column prop="device_name" label="设备名字" width="150"></el-table-column>
	  <el-table-column prop="url_bihe2" label="报警触发播放" width="240"></el-table-column>
	  <el-table-column prop="url_duankai2" label="报警接触播放" width="240"></el-table-column>
   
      <el-table-column prop="enable" label="工作状态" width="100">
				<template slot-scope="scope">
				    <!--el-switch
				      active-value="2"
				      inactive-value="0"
							active-color="#13ce66"
							inactive-color="#ff4949"
							@change="enablechange(warningSetList[scope.$index].enable,warningSetList[scope.$index].id)"
				      v-model="warningSetList[scope.$index].enable"
				    ></el-switch-->
					<el-button
					  type="danger"
					  icon="el-icon-edit"
					  @click.native.prevent="enablechange(warningSetList[scope.$index].enable,warningSetList[scope.$index].id)"
					  size="small"
					  plain
					:disabled="quedinganqiuenable22" >应用</el-button> 
				  </template>
				</el-table-column>
			</el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click.native.prevent="goEdit(scope.$index, warningSetList)"
            size="small"
            plain
          >编辑</el-button> 
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="自动报警设置" :visible.sync="dialogVisible_adddevice" width="1000px">
      <el-form ref="form" label-width="80px" align="left">
  
				
				   
				<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
					<el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
				</el-checkbox-group>
        <div id="transfer1" style="text-align: left"  v-show="biheenable" >
          <h3 style="margin: 20px 0 20px">输入闭合触发</h3> 
					
          <el-form-item label="文件选择 :">
            <el-select v-model="warningSet.file1" placeholder="请选择报警文件"  >
              <el-option
                style="width: 300px"
                v-for="(item,index) in tableDatafilelist"
                :label="item.filename"
                :value="item.url"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        
        </div>

        <div id="transfer2" style="text-align: left"  v-show="duankaienable"  >
          <h3 style="margin: 20px 0 20px">输入断开报触发</h3>
          <el-form-item label="文件选择 :">
            <el-select v-model="warningSet.file2" placeholder="请选择报警文件"    >
              <el-option
                style="width: 300px"
                v-for="(item,index) in tableDatafilelist"
                :label="item.filename"
                :value="item.url"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
       
        </div>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_adddevice=false">取消</el-button>
        <el-button type="primary" @click="edit"  :disabled="quedinganqiuenable" >确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
const cityOptions = ['启用闭合触发', '启用断开触发'];
export default {
  data() {
    return {
			checkAll: false,
      checkedCities: ['启用闭合触发', '启用断开触发'],
      cities: cityOptions,
      isIndeterminate: true,
      tableData: [],
			tnodeid:0,
			sel1:[],
			sel2:[],
			options: [],
			nodeid: "",
      tableDatafilelist: [],
      warningSetList: [],
      warningSet: {
        flag: true,
        seedList1: {
          data: [],
          value: []
        },
        seedList2: {
          data: [],
          value: []
        },
        file1: "",
        file2: "",
        portwr: "",
        portct: "",
        seed: "",
        ip: "",
        id: "",
        shenhe: "" 
      },
			quedinganqiuenable:false,
			quedinganqiuenable22:false,
			duankaienable:true,
			biheenable:true,
      dialogVisible_adddevice: false
    };
  },
	 
  created() {
    this.reflash_nodeinfo();
  },
  methods: {
		handleCheckedCitiesChange:function(value) {
		     let checkedCount = value.length;
		      
				 console.log(value);
				 if(checkedCount > 0){
					 this.quedinganqiuenable = false;
					 if(checkedCount == 2){
						 this.duankaienable = true;
						 this.biheenable = true;		
											
					 }else{
						 if(value[0] == "启用闭合触发"){
							 console.log("danbihe")
							 this.biheenable = true;
							 this.duankaienable = false;
						 }else{
							 console.log("danduankai")
							 this.biheenable = false;
							 this.duankaienable = true;
						 }
					 }
						
				 }else{
					 this.quedinganqiuenable = false;
					 this.biheenable = false;
					 this.duankaienable = false;					 
				 }
				  
		      
		   },
		shenhechange:function(v,id){
			console.log(v+"  "+id);
		},
		enablechange:function(v,id){
			this.quedinganqiuenable22 = true;
			console.log(v+"  "+id);
			let en =0;
			if(v == 2 ){
				en = 1;
			}else if(v == 0){
				en = 3;
			}else{
				return;
			}
			axios.get("/Warningeableauto.php", {
			    params: {
			      username: sessionStorage.getItem("username"),
			      passwd:   sessionStorage.getItem("passwd"),
				  enable:en,
				  id:id
			    }
			  })
			  .then(
			    function(res) {
			      if (res.data.res) {
			        this.reflash_devlist(); 
			        this.$forceUpdate();
					
					this.$alert('状态应用及更新成功', '自动报警设置', {
					  confirmButtonText: '确定',
					  callback: action => {
						 this.$notify.success({
						   title: "Info",
						   message: "状态更新成功",
						   showClose: true,								
						 });
						 this.quedinganqiuenable22 = false;
					  }
					});
			      }else{
					  this.$message({
					    type: "warning",
					    message: "设备不在线或其他条件不满足"
					  });
					  
				  }
				  this.quedinganqiuenable22 = false;
			    }.bind(this)
			  )
			  .catch(function(res) {
			    console.log(res);
			  });
		},
		nodechange_:function(){
			axios
			  .get("/get_user_nodedevws.php", {
			    params: {
			      username: sessionStorage.getItem("username"),
			      passwd: sessionStorage.getItem("passwd"),
			      nodeid: this.nodeid
			    }
			  })
			  .then(
			    function(res) {
			      if (res.data.res) {
								this.warningSet.seedList1.data = res.data.dev_info;
								this.warningSet.seedList2.data = res.data.dev_info;
								this.warningSet.ip = res.data.nodeip;
								this.warningSet.portwr = res.data.nodeport6;
								this.warningSet.portct = res.data.nodeport3; 
							  this.warningSet.seedList1.value = [];
							  this.warningSet.seedList2.value = [];
								console.log("----------------");
								console.log(this.nodeid);
								console.log(this.tnodeid);
								console.log(this.sel1);
								console.log(this.sel2);
								 
								if(this.nodeid == this.tnodeid){ 
									this.warningSet.seedList1.value = this.sel1;
									this.warningSet.seedList2.value = this.sel2;	
								}else{
									this.warningSet.seedList1.value = [];
									this.warningSet.seedList2.value = [];	
								}
								
			        this.$forceUpdate();
			      }
			    }.bind(this)
			  )
			  .catch(function(res) {
			    console.log(res);
			  });
		},
		handleChange1(value, direction, movedKeys) {  
				console.log( this.warningSet.seedList2.value);
      },
	  handleChange2(value, direction, movedKeys) {
				console.log( this.warningSet.seedList1.value); 
    },
		reflash_nodeinfo: function() {
		  axios
		    .get("/get_user_node.php", {
		      params: {
		        username: sessionStorage.getItem("username"),
		        passwd: sessionStorage.getItem("passwd")
		      }
		    })
		    .then(
		      function(res) {
		        if (res.data.res) {
		          this.options = res.data.outlableid;		
		          this.$forceUpdate();
		        }
		      }.bind(this)
		    )
		    .catch(function(res) {
		      console.log(res);
		    });
		},
		reflash_nodeinfosss: function(tnodeids) {
		  axios
		    .get("/get_user_node.php", {
		      params: {
		        username: sessionStorage.getItem("username"),
		        passwd: sessionStorage.getItem("passwd")
		      }
		    })
		    .then(
		      function(res) {
		        if (res.data.res) {
		          this.options = res.data.outlableid;		
							this.nodeid = tnodeids;
							this.nodechange_();
		          this.$forceUpdate();
		        }
		      }.bind(this)
		    )
		    .catch(function(res) {
		      console.log(res);
		    });
		},
    goEdit(index, rows) {
      
      this.get_file_list();
 
      this.warningSet.seed = rows[index].seed;
      this.warningSet.portct = rows[index].portct;
      this.warningSet.id = rows[index].id;
	  this.warningSet.ip = rows[index].nodeip;    
      this.dialogVisible_adddevice = true;
    },
    edit() {
     console.log("edit"+"1");
			  if (this.warningSet.seed == "") {
				this.$message({
				  type: "warning",
				  message: "报警设备不能为空"
				});
				return;
			  } 
    
		 
            var url_bihe;
			var url_duankai;
    
			if(this.duankaienable){
				console.log("this.warningSet.file2 +====="+this.warningSet.file2 )
				if (this.warningSet.file2 == "") {
				    url_duankai = "http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
				}else{
					url_duankai = this.warningSet.file2;					
				}			  
			}
			 
			if(this.biheenable){
				console.log("this.warningSet.file1 +====="+this.warningSet.file1 )
				 if (this.warningSet.file1== "") {
					 url_bihe ="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
				 }else{
					 url_bihe= this.warningSet.file1;
				 }				
			}
			 
			if(!this.duankaienable){			 
				url_duankai = "http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
			}
			if(!this.biheenable){
				 url_bihe ="http://x/x/x/x/5peg5oql6K2m6YWN572u.mp3";
			}  

      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("user_id", sessionStorage.getItem("id"));
      data.append("enable", 0); 
      data.append("portct", this.warningSet.portct);
      data.append("seed", this.warningSet.seed);
      data.append("ip", this.warningSet.ip);
      data.append("url_bihe", url_bihe);
      data.append("url_duankai", url_duankai);
      data.append("id", this.warningSet.id);
	  data.append("play_nodeid", this.nodeid);
	  
      axios
        .post("/warningsetauto.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              console.log(res.data);
              this.$forceUpdate();
              this.$notify.success({
                title: "Info",
                message: "编辑成功",
                showClose: false,								
              });
							this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "编辑出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice = false;
    },
    putMode() {
      var a = document.getElementById("transfer1");
      var b = document.getElementById("transfer2");
      if (this.warningSet.flag) {
        setTimeout(() => {
          this.warningSet.flag = false;
          a.style.transform = "rotateY(0deg)";
        }, 500);
        a.style.transition = "all 0.5s linear";
        a.style.transform = "rotateY(345deg)";
      } else {
        setTimeout(() => {
          this.warningSet.flag = true;
          b.style.transform = "rotateY(0deg)";
        }, 500);
        b.style.transition = "all 0.5s linear";
        b.style.transform = "rotateY(345deg)";
      }
    },
    reflash_devlist: function() {
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      axios
        .post("/warningsetlistauto.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.warningSetList = res.data.dataJson;
			  this.warningSetList.forEach((item, index) => {
			    item.url_bihe2 = Base64.decode(item.url_bihe2);			    
			  });
			  this.warningSetList.forEach((item, index) => {
			    item.url_duankai2 = Base64.decode(item.url_duankai2);			    
			  });
			  
              console.log(this.warningSetList);
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    reflash_devlist2: function() {
      this.warningSet.seedList = [];
      axios
        .get("/get_devicelistweb.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData = res.data.dataJson;

              const data = [];
              for (let i = 0; i < this.tableData.length; i++) {
               // if (this.tableData[i].iswarning == "1") {
                  data.push({
                    key: this.tableData[i].seed,
                    label: this.tableData[i].name
                  });
               // }
              }
              this.warningSet.seedList1.data = data;
              this.warningSet.seedList2.data = data;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              let its= res.data.file;
              its.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
							this.tableDatafilelist  =  its;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px  ;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/warmingauto.vue